import p_01 from "@/assets/publicationRouter/publicationFile/p_01.pdf";
import p_02 from "@/assets/publicationRouter/publicationFile/p_02.pdf";

var publication_path = [p_01, p_02];
export { publication_path };
